import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../context/authContext';

const PrivateRouteWithLayout = props => {
  const { layout: Layout, component: Component, allowedRoles, requiresClub, ...rest } = props;
 const { isAuthenticated, loading, user } = useAuth();

   if (loading) {
    return (
      <div>Loading...</div> // Or your loading spinner
    );
  }

  const userRole = Number(user?.role ?? user?.userType ?? user?.type ?? user?.role_id ?? user?.roleId);
  const isRoleAllowed = !allowedRoles || allowedRoles.includes(userRole);
  // A club is "selected" when setSelectedClub has run (sets user.selectedClub);
  // browsing away clears it. This is the same signal the old isSessionClubSelected
  // boolean tracked, now read straight from the user so there is one source.
  const needsClub = requiresClub && userRole === 100 && !user?.selectedClub;

  return (
    <Route

      {...rest}
      render={matchProps => (
        !isAuthenticated ? (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: matchProps.location }
            }}
          />
        ) : !isRoleAllowed ? (
          <Redirect to={{ pathname: "/" }} />
        ) : needsClub ? (
          <Redirect to={{ pathname: "/ClubManagement" }} />
        ) : (
          <Layout>
            <Component {...matchProps} />
          </Layout>
        )
      )}
    />
    // {/* <Route
    //   {...rest}
    //   render={matchProps =>
    //     userAuthState.authTokens ? (
    //       <Layout>
    //         {/* {alert(
    //           'Private:' +
    //             userAuthState.user +
    //             ' token: ' +
    //             userAuthState.authTokens
    //         )} */}
    //         <Component {...matchProps} />
    //       </Layout>
    //     ) : (
    //         <Redirect
    //           to={{ pathname: '/log-in', state: { referer: props.location } }}
    //         />
    //       )
    //   }
    // /> */}
  );
};

PrivateRouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string,
  allowedRoles: PropTypes.array,
  requiresClub: PropTypes.bool
};
export default PrivateRouteWithLayout;